import React from 'react'
import { useQuery } from '@apollo/react-hooks'

import { walletQueries } from '../graphql/queries'
import { Dashboard, DataPrivacy } from '../containers'

const DashboardHomeRoute = () => {
  const { data, loading } = useQuery(walletQueries.GET_MY_SUBSCRIPTION, {
    variables: {
      subscriptionType: 'data-privacy',
    },
  })

  if (loading) {
    return null
  }

  const subscription = data?.subscription

  if (subscription?.planIdentifier && subscription.active) {
    return <DataPrivacy />
  }

  return <Dashboard />
}

export default DashboardHomeRoute

